export default __webpack_public_path__ + "static/media/pin.cf46b05a.svg";